export enum AuthRoutes {
  login = 'login',
  otp = 'verify-code',
  register = 'register',
  registerNumber = 'register-number',
  PersonalDetails = 'personal-details',
  CompanyDetails = 'company-details',
  OtherDetails = 'other-details',
  BankDetails = 'bank-details',
}
